import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Container, Grid, Paper, Typography, Button, Box, Chip, Divider } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

// Componentes
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import QUDProgress from "../../../../components/progress";
import MUIDataTable from "mui-datatables"; // Reutilizamos la tabla

// Controladores
import { getPlan } from "../../../../controllers/company/subscriptions/PlansController";
import { getSubscriptions } from "../../../../controllers/company/subscriptions/SubscriptionsController";


export default function PlanDetail() {
    const { id } = useParams();
    const history = useHistory();
    
    const [plan, setPlan] = useState(null);
    const [subscribers, setSubscribers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, [id]);

    const loadData = async () => {
        setIsLoading(true);
        // 1. Cargar datos del Plan
        const planResponse = await getPlan(id);
        // 2. Cargar suscriptores de este plan
        const subsResponse = await getSubscriptions(id);

        if (planResponse.success) {
            setPlan(planResponse.data);
        }
        if (subsResponse.success) {
            setSubscribers(subsResponse.data);
        }
        setIsLoading(false);
    };

    // Columnas para la tabla de suscriptores
    const columns = [
        {
            name: 'payer',
            label: 'Pagador (Padre)',
            options: {
                customBodyRender: (value) => `${value.name} ${value.last_name}`
            }
        },
        {
            name: 'beneficiary',
            label: 'Beneficiario (Alumno)',
            options: {
                customBodyRender: (value) => `${value.name} ${value.last_name}`
            }
        },
        {
            name: 'status',
            label: 'Estado',
            options: {
                customBodyRender: (value) => {
                    const color = value === 'active' ? 'success' : (value === 'pending' ? 'warning' : 'error');
                    return <Chip label={value.toUpperCase()} color={color} size="small" />;
                }
            }
        },
        {
            name: 'next_renewal_date',
            label: 'Próximo Pago',
            options: {
                customBodyRender: (value) => value ? new Date(value).toLocaleDateString() : 'N/A'
            }
        }
    ];

    if (isLoading) return <QUDProgress open={true} />;
    if (!plan) return <Typography>Plan no encontrado</Typography>;

    return (
        <Container maxWidth="xl">
            <CustomBreadcrumbs 
                returnTo='/subscriptions' 
                crumbs={[
                    { name: 'Suscripciones', link: '/subscriptions' },
                    { name: 'Planes', link: '/subscriptions/plans' },
                    { name: plan.name, link: '#' }
                ]}
            />

            {/* --- ENCABEZADO DEL PLAN --- */}
            <Paper elevation={3} sx={{ p: 3, mt: 3, mb: 4, bgcolor: '#f5f9ff' }}>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h4" fontWeight="bold" color="primary">
                            {plan.name}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            ${parseFloat(plan.price).toFixed(2)} / {plan.interval_count > 1 ? plan.interval_count : ''} {plan.billing_interval}
                        </Typography>
                        {plan.description && (
                            <Typography variant="body2" sx={{ mt: 1 }}>{plan.description}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={4} display="flex" justifyContent="flex-end">
                        <Button 
                            variant="contained" 
                            size="large"
                            startIcon={<PersonAddIcon />}
                            // Llevamos al formulario de inscripción, pasando el ID del plan
                            //onClick={() => history.push(`/subscriptions/enroll?plan_id=${plan.id}`)}
                            onClick={() => history.push(`/subscriptions/enroll/${plan.id}`)}
                        >
                            Inscribir Alumno
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* --- TABLA DE SUSCRIPTORES --- */}
            <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                Alumnos Inscritos ({subscribers.length})
            </Typography>
            
            <MUIDataTable
                title={"Listado de Suscripciones"}
                data={subscribers}
                columns={columns}
                options={{
                    selectableRows: 'none',
                    elevation: 1
                }}
            />

        </Container>
    );
}